import { render } from "./CodeEditor.vue?vue&type=template&id=7a38280c"
import script from "./CodeEditor.vue?vue&type=script&lang=js"
export * from "./CodeEditor.vue?vue&type=script&lang=js"

import "./CodeEditor.vue?vue&type=style&index=0&id=7a38280c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__